import {Component, computed, input, model, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectButtonModule} from 'primeng/selectbutton';
import {TranslocoPipe} from '@jsverse/transloco';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-model-field-select-button',
  imports: [CommonModule, FormsModule, SelectButtonModule, TranslocoPipe, DirectusTooltipComponent],
  templateUrl: './model-field-select-button.component.html',
  styleUrl: './model-field-select-button.component.scss',
})
export class ModelFieldSelectButtonComponent {
  id = input.required<string>();
  options = input.required<any[]>();
  label = input<string>('');
  tooltipKey = input<string>('');
  isReadOnly = input<boolean>(false);
  smallLabel = input<boolean>(false);
  isRequired = input<boolean>(false);
  allowEmpty = input<boolean>(true);

  optionLabel = input<string>('key');
  optionValue = input<string>('value');
  optionIcon = input<string>('icon');
  styleClass = input<string>('');

  value = model<any>();

  protected readonly isTouched = signal<boolean>(false);

  protected readonly showInvalid = computed<boolean>(
    () => this.isTouched() && this.isRequired() && this.value() == null,
  );

  readonly visibleOptions = computed(() => {
    const options = this.options();
    const currentValue = this.value();
    if (!this.isReadOnly() || currentValue === null || currentValue === undefined) {
      return options;
    }

    return options.filter((option) => option[this.optionValue()] === currentValue);
  });

  protected markAsTouched(): void {
    this.isTouched.set(true);
  }
}
